import { render, staticRenderFns } from "./SectionBecomePartner.vue?vue&type=template&id=4323ee78&scoped=true"
import script from "./SectionBecomePartner.vue?vue&type=script&lang=ts"
export * from "./SectionBecomePartner.vue?vue&type=script&lang=ts"
import style0 from "./SectionBecomePartner.vue?vue&type=style&index=0&id=4323ee78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4323ee78",
  null
  
)

export default component.exports